import React from 'react'
import Popup from 'reactjs-popup'
import TileDetails from './TileDetails';

const Tile = (props) => {
  return(

  <td
    colSpan={props.colSpan}
    className="p-1"
  >
    <Popup
      trigger={
        <button 
          className="btn btn-link btn-block text-white text-left py-0 px-1 text-decoration-none shadow-sm"
          style={{
            fontSize:12,
            fontWeight: 500, 
            backgroundColor: `${props.color}`,
            opacity: `${props.entry.hidden ? "0.2" : "1"}`
          }}
        >
          {props.entry.person}
        </button>
      }
      on="hover"
    >
    <TileDetails details={props.entry} room={props.room}/>
    </Popup>
  
    
  </td>
  )
}



export default Tile